import { trackClick } from '@hotjar/webapp/features/Playbacks/utils/tracking';
import { Store } from '../../../store/player/types';
import { pause } from './pause';
import { play } from './play';
import type { MouseEvent } from 'react';

/**
 * Toggle play / pause.
 */
export const togglePlayPause = (
  store: Store,
  event: MouseEvent | KeyboardEvent,
  helpHotjarUrl: string,
): void => {
  const { loaded, done, playing, recording } = store.getState();

  if (done) {
    return;
  }

  if ('key' in event) {
    if (playing) {
      pause(store, true);
    } else {
      play(store, true);
    }
  } else {
    let clickedElement;
    if (loaded && event) {
      const scene: HTMLIFrameElement | null = document.querySelector('#content-iframes .active');
      if (scene && scene.contentDocument) {
        const sceneRect = scene.getBoundingClientRect();

        // Get X,Y click position in page.
        const pageClickX = event.pageX as number;
        const pageClickY = event.pageY;

        // Get X,Y click position in player.
        const clickPositionX = pageClickX - sceneRect.x;
        const clickPositionY = pageClickY - sceneRect.y;

        // Get scale size of the player.
        const scaleX = sceneRect.width / scene.offsetWidth;
        const scaleY = sceneRect.height / scene.offsetHeight;

        // Scale X,Y click position to actual size of the page.
        const scaledClickPositionX = clickPositionX / scaleX;
        const scaledClickPositionY = clickPositionY / scaleY;

        clickedElement = scene.contentDocument.elementFromPoint(
          scaledClickPositionX,
          scaledClickPositionY,
        ) as HTMLIFrameElement;
      }
    }
    if (clickedElement && clickedElement.hasAttribute('data-iframe-blocked')) {
      pause(store, true);

      if (recording) {
        trackClick(recording, {
          element_name: 'playback_blocked_iframe_learn-more',
          ui_position: 'playback_blocked_iframe_overlay-copy',
        });
      }

      window.open(`${helpHotjarUrl}/articles/115011624347`, '_blank', 'noopener');
    } else if (playing) {
      pause(store, true);
    } else {
      play(store, true);
    }
  }
};
